import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { CreditSettings } from '../../../services/credit.service';

/** What the dialog closes with. The parent orchestrates the actual save +
 *  Stripe redirect (a fresh enable may need the card authorised first). */
export interface AutoRechargeDialogResult {
  action: 'save' | 'disable';
  threshold_eur?: number;
  amount_eur?: number;
}

@Component({
  selector: 'app-auto-recharge-dialog',
  templateUrl: './auto-recharge-dialog.component.html',
  styleUrl: './auto-recharge-dialog.component.scss',
})
export class AutoRechargeDialogComponent implements OnInit {
  @Input() settings?: CreditSettings;
  /** True when auto-recharge is currently off and we're turning it on — hides
   *  the "Ausschalten" button and labels the primary action as "activate". */
  @Input() enabling = false;

  form = this.fb.group({
    threshold_eur: [10, [Validators.required, Validators.min(0), Validators.pattern(/^\d+$/)]],
    amount_eur: [25, [Validators.required, Validators.min(10), Validators.pattern(/^\d+$/)]],
  });

  constructor(
    public dialogRef: NbDialogRef<AutoRechargeDialogComponent>,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    const s = this.settings;
    if (s) {
      this.form.patchValue({
        threshold_eur: s.auto_recharge_threshold_eur,
        amount_eur: s.auto_recharge_amount_eur,
      });
      const min = s.min_purchase_eur ?? 10;
      this.form.controls.amount_eur.setValidators([
        Validators.required,
        Validators.min(min),
        Validators.pattern(/^\d+$/),
      ]);
    }
  }

  save() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.dialogRef.close({
      action: 'save',
      threshold_eur: Number(this.form.controls.threshold_eur.value),
      amount_eur: Number(this.form.controls.amount_eur.value),
    } as AutoRechargeDialogResult);
  }

  disable() {
    this.dialogRef.close({ action: 'disable' } as AutoRechargeDialogResult);
  }

  close() {
    this.dialogRef.close();
  }
}
